export const mapSearchKeys = {
	all: ['mapSearch'],
	places: (category, bounds, zoom) => ['mapSearch', 'places', category, bounds, zoom],
	placeDetails: (placeId) => ['mapSearch', 'placeDetails', placeId],
	searchByName: (query, bounds) => ['mapSearch', 'searchByName', query, bounds],
};
